"use client";

export interface CurrentVisitsHeaderProps {
  isLoading?: boolean;
}

/** Kinsa shows a "Current" heading above active visits */
export function CurrentVisitsHeader({
  isLoading = false,
}: CurrentVisitsHeaderProps) {
  return (
    <h3
      className={`font-heading font-medium text-xl leading-7 tracking-[0.2px] text-text-200 ${isLoading ? "animate-pulse opacity-60" : ""}`}
    >
      Current
    </h3>
  );
}

/** Kinsa does not show a "See past visits" button — past visits are inline */
export function SeePastVisitsButton() {
  return null;
}
